<template>
  <div class="section">
    <div class="header">
      <p class="title">{{ title }}</p>
      <div class="more" @click="seeMore" v-if="showMore">
        <p>更多</p>
        <img src="@/assets/images/community/icon_more.png" alt="" />
      </div>
    </div>
    <p class="no-login" v-if="$store.state.token && !recommend.length">
      <span class="emptyTip">{{ tip }}</span>
    </p>
    <router-link
      v-if="!$store.state.token"
      class="no-login"
      :to="{ name: 'Login' }"
    >
      <span>登录</span>
      后才能查看哦～
    </router-link>
    <template v-else>
      <div
        class="section_item"
        v-for="item in recommend"
        :key="item.id"
        @click="toOtherDetail(item)"
      >
        <div class="section_item_header">
          <img :src="item.avatar" alt="" />
          <p class="username">{{ item.nickname }}</p>
        </div>
        <p class="section_item_title">
          {{ item.main ? item.main.title : item.title }}
        </p>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    recommend: {
      type: Array,
      default: () => [],
    },
    linkUrl: {
      type: String,
      default: "",
    },
    showMore: {
      type: Boolean,
      default: false,
    },
    tip: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    //获取数据
    getData() {
      this.$emit("getData");
    },
    handleZan(id) {
      this.$emit("handleZan", id);
      this.$emit("refresh");
    },
    handleComment(item, index) {
      this.$emit("handleComment", item, index);
    },
    seeMore() {
      this.$emit("seeMore");
    },
    toOtherDetail(item) {
      this.$emit("toOtherDetail", item);
    },
  },
};
</script>
<style lang="scss" scoped>
.section {
  background-color: #fff;
  border-radius: 4px;
  padding: 16px;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      font-size: 16px;
      font-weight: 600;
      color: #333;
    }
    .more {
      display: flex;
      color: #666;
      font-size: 14px;
      align-items: center;
      cursor: pointer;
      img {
        width: 16px;
        height: 16px;
        margin-bottom: 3px;
      }
    }
  }
  .no-login {
    display: block;
    height: 147px;
    background: url("~@/assets/images/community/no_login_bg.png") center
      no-repeat #fff;
    background-size: 221px 154px;
    line-height: 250px;
    text-align: center;
    font-size: 14px;
    color: #999;
    margin-top: 20px;
    span {
      color: $primary-color;
      margin-left: 22px;
    }
    .emptyTip {
      color: #999;
    }
  }
  .section_item {
    padding: 16px 0;
    position: relative;
    cursor: pointer;
    border-bottom: 1px solid #f1f1f1;
    &:last-child {
      border: 0;
      padding-bottom: 0;
    }
    .section_item_header {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #333;
      .username {
        font-weight: bold;
      }
      img {
        width: 26px;
        height: 26px;
        border-radius: 50%;
        margin-right: 8px;
        border: 1px solid #e7e7e7;
      }
    }
    .section_item_title {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      font-size: 14px;
      line-height: 22px;
      margin-top: 8px;
      overflow: hidden;
    }
  }
}
</style>
